<div class="fieldAttachmentModal" *ngIf="field" appFileDragDetector>
    <div class="d-flex justify-content-between align-items-center matDialogBorderBottom" *transloco="let translate">
        <h4 class="matDialogTitle" mat-dialog-title [textContent]="translate('Upload File')"></h4>
        <span class="material-icons mb-1" mat-dialog-close>close</span>
    </div>
    <mat-dialog-content class="mat-typography matDialogBody">
        <div *transloco="let translate">
            <div class="fieldAttachmentRow" [hidden]="inReadOnlyMode">
                <span class="field-display-name">
                    <span [textContent]="field.displayName"></span> :
                </span>
                <span class="file-upload-item">
                    <app-file-upload [data]="fieldAttachmentData" [clearFiles]="clearFiles" (newValue)="onNewValue($event)" (fileName)="fileName = $event" [supportedFormats]="field.attachment && field.attachment.supportedTypes" (isFileTypeSupported)="onFileTypeSupportCheck($event)" [isDisabled]="maxFileCountReached"></app-file-upload>
                </span>
                <span class="upload-btn">
                    <material-button [color]="'primary'" [classList]="['!w-auto']" [disabled]="!files || files.length === 0 || !isFileTypeSupported || !isMaxFileSizeAllowed || maxFileCountReached" [text]="translate('Upload')" (buttonClicked)="startUpload()"></material-button>
                </span>
            </div>
            <div [hidden]="inReadOnlyMode">
                <span><span [textContent]="translate('Maximum allowed files count')"></span>:<strong [textContent]="field.attachment && field.attachment.maxFilesCount"></strong><span class="alreadyReached" *ngIf="maxFileCountReached"> (<span [textContent]="translate('Reached')"></span>)</span></span>
            </div>
            <div class="fieldAttachedFileName row" [hidden]="inReadOnlyMode || !fileName">
                <span class="col-xs-5 fileNameLabel">
                    <span [textContent]="translate('File Name')"></span> :
                </span>
                <span class="col-xs-7 fileNameValue" [title]="fileName">
                    <span [textContent]="fileName"></span>
                </span>
            </div>
            <div class="fieldAttachedFileName row" [hidden]="!inReadOnlyMode">
                <span class="col-xs-5 fileNameLabel">
                    <span [textContent]="translate('Field Name')"></span> :
                </span>
                <span class="col-xs-7 fileNameValue" [title]="field.displayName">
                    <span [textContent]="field.displayName"></span>
                </span>
            </div>
            <div class="fileTypeSupport" *ngIf="!isFileTypeSupported">
                <span class="col-xs-12"><span [textContent]="translate('Please select')"></span> <span [textContent]="field.attachment && field.attachment.supportedTypes"></span> <span [textContent]="translate('file format to upload')"></span></span>
            </div>
            <div class="fileTypeSupport maxFileSizeAllowed" *ngIf="!isMaxFileSizeAllowed">
                <span class="col-xs-12"><span [textContent]="translate('Please upload a file of size less than')"></span> <span [textContent]="field.attachment && field.attachment.maxSize"></span> <span [textContent]="translate('MB')"></span></span>
            </div>
            <div class="uploadedFilesListContainer">
                <material-table [allTableColumns]="allColumns" [selectedColumns]="selectedColumns" [data]="tableData" [recordActions]="recordActions"></material-table>
            </div>
        </div>
    </mat-dialog-content>
</div>
